import { withConditionalPlaceHolder } from '@adobe/aem-core-components-react-base';
import { ComponentType, FC } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { MappedAEMProperties } from '../../types';

type EditConfigType<T> = { emptyLabel: string; isEmpty: (props: T) => boolean };

export const WithEmptyPlaceholder = <T extends MappedAEMProperties | MappedComponentProperties>(
  comp: ComponentType<T>,
  editConfig: EditConfigType<T>,
): [FC<T>, EditConfigType<T>] => {
  const Wrapped = withConditionalPlaceHolder(comp, editConfig.isEmpty, undefined, editConfig.emptyLabel);

  return [(props: T) => <Wrapped {...props} />, editConfig];
};
